import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAppNavigation } from 'src/routes';

export const Site = () => {
  const flags = useFlags();
  const { navigateTo } = useAppNavigation();
  useEffect(() => {
    if (!flags.releaseSites) {
      navigateTo.errorPage();
    }
  }, [flags]);
  return <Outlet />;
};
